import {
  PHONE,
  GRID,
  mediaQueries
} from 'bento-ordering/base/constants/mediaQueries';

export const isMobileMedia = () => {
  return window.matchMedia(mediaQueries[PHONE]).matches;
};

export const isSmallerThanGrid = () => {
  return window.matchMedia(mediaQueries[GRID]).matches;
};
